<template>
	<div>
		<BreadcrumbHeader
				title="Dashboard"
				show-backlink
				:back-route="companyRieOverview(companyId)"
		/>
		<div class="rie-info">
			<h1 class="rie-title">{{ currentRie?.title }}</h1>

			<NuxtLink :to="rieDetailLink(companyId, rieId)">
				Gegevens bekijken
			</NuxtLink>
		</div>

		<RieDashboard
				:read-only="!isAllowedToWriteToRie"
				:overview-data="store.overviewData"
				:company-id="companyId"
				:rie-id="rieId"
		/>
	</div>
</template>
<script setup lang="ts">
	import {useRoute} from 'vue-router';
	import {computed} from 'vue';
	import {companyRieOverview, pageNames, rieDetailLink} from '~/lib/pageHelper';
	import {useDashboardStore} from '~/store/dashboard/dashboard';
	import {definePageMeta} from '#imports';
	import {useCompanyRiesStore} from '~/store/company/companyRies';
	import BreadcrumbHeader from '~/components/generic/BreadcrumbHeader.vue';
	import RieDashboard from '~/components/dashboard/RieDashboard.vue';
	import {useUserDetailsStore} from '~/store/global/userdetails';
	import {isValidRieIdParam} from '~/lib/validators/rieId';

	const route = useRoute();
	const store = useDashboardStore();
	const companyRieStore = useCompanyRiesStore();
	const userDetailsStore = useUserDetailsStore();

	const isAllowedToWriteToRie = computed(() => userDetailsStore.isAllowedToWriteToRie);

	const companyId = computed(() => Number(route.params.companyId as string));
	const rieId = computed(() => route.params.rieId as string);

	store.refreshData(rieId.value);
	companyRieStore.fetchCompanyRies(companyId.value);

	const currentRie = computed(() => {
		return companyRieStore.ries.find(rie => rie.id.toString() === rieId.value);
	});

	definePageMeta({
		name: pageNames.rieDashboard,
		pageInfo: {
			title: 'Dashboard',
			mobileTitle: 'Dashboard',
			showBacklink: false
		},
		hideBreadcrumb: true,
		alias: [
			'',
			'dashboard'
		],
		validate: isValidRieIdParam
	});
</script>

<style scoped>
	.rie-info {
		padding: 10px;
		background: var(--color-grey-50);
		border-radius: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 0 40px;

		.rie-title {
			font-size: var(--font-size-p-4);
			line-height: var(--line-height-p-4);
		}
	}
</style>
